import {
  CalculateSeasonalMatrixRequest,
  MatrixContractSettlement,
  MatrixTerm,
  SeasonalMatrixStripType,
} from '../../../../Generated/Mark-It-View-Api';
import { MatrixTermLabels } from '../Matrix/MatrixLabels';
import { RollingContractNumberLabels } from './SeasonalMatrixLabels';

export interface ContractOption {
  year: number;
  month: number;
  label: string;
}

// What the user picked on the form. Only the fields for the chosen strip type are used.
export interface SeasonalMatrixSelection {
  productId: number;
  quoteDate: string;
  stripType: SeasonalMatrixStripType;
  term: MatrixTerm;
  targetYear: number;
  targetContract: ContractOption | null;
  rollingContractNumber: number;
  contractSettlement: MatrixContractSettlement;
  applyPpi: boolean;
}

export function buildSeasonalMatrixRequest(selection: SeasonalMatrixSelection): CalculateSeasonalMatrixRequest {
  const { stripType } = selection;
  return {
    productId: selection.productId,
    quoteDate: selection.quoteDate,
    stripType: stripType,
    term: stripType === SeasonalMatrixStripType.Strip ? selection.term : undefined,
    targetYear: stripType === SeasonalMatrixStripType.Strip
      ? selection.targetYear
      : stripType === SeasonalMatrixStripType.Month ? selection.targetContract?.year : undefined,
    targetMonth: stripType === SeasonalMatrixStripType.Month ? selection.targetContract?.month : undefined,
    rollingContractNumber: stripType === SeasonalMatrixStripType.Rolling ? selection.rollingContractNumber : undefined,
    contractSettlement: selection.contractSettlement,
    applyPpi: selection.applyPpi,
  };
}

// The contracts being priced, in words, such as "Annual 2027", "Mar 2027" or "1st Contract".
export function getTargetLabel(selection: SeasonalMatrixSelection): string {
  switch (selection.stripType) {
    case SeasonalMatrixStripType.Strip:
      return `${MatrixTermLabels[selection.term]} ${selection.targetYear}`;
    case SeasonalMatrixStripType.Month:
      return selection.targetContract?.label ?? '';
    default:
      return RollingContractNumberLabels[selection.rollingContractNumber];
  }
}
